import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=1ffc6373&"
import script from "./PriceTable.vue?vue&type=script&lang=js&"
export * from "./PriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffc6373')) {
      api.createRecord('1ffc6373', component.options)
    } else {
      api.reload('1ffc6373', component.options)
    }
    module.hot.accept("./PriceTable.vue?vue&type=template&id=1ffc6373&", function () {
      api.rerender('1ffc6373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/PriceTable.vue"
export default component.exports